import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  AWSDateTime: { input: any; output: any };
};

export type AppConfig = {
  __typename?: "AppConfig";
  disableApp: Scalars["Boolean"]["output"];
  disableTI: Scalars["Boolean"]["output"];
  tiStartDate?: Maybe<Scalars["AWSDateTime"]["output"]>;
  tiEndDate?: Maybe<Scalars["AWSDateTime"]["output"]>;
  tmcStartDate?: Maybe<Scalars["AWSDateTime"]["output"]>;
  tmcEndDate?: Maybe<Scalars["AWSDateTime"]["output"]>;
  appFuncStartDate?: Maybe<Scalars["AWSDateTime"]["output"]>;
  appFuncEndDate?: Maybe<Scalars["AWSDateTime"]["output"]>;
  disableTICancellation: Scalars["Boolean"]["output"];
  disableTIPurchase: Scalars["Boolean"]["output"];
  disableTIRenewals: Scalars["Boolean"]["output"];
  disableTMC: Scalars["Boolean"]["output"];
  disabledMessageApp?: Maybe<Scalars["String"]["output"]>;
  disabledMessageTI?: Maybe<Scalars["String"]["output"]>;
  disabledMessageTICancellation?: Maybe<Scalars["String"]["output"]>;
  disabledMessageTIPurchase?: Maybe<Scalars["String"]["output"]>;
  disabledMessageTIRenewals?: Maybe<Scalars["String"]["output"]>;
  disabledMessageTMC?: Maybe<Scalars["String"]["output"]>;
  enableJuneAutorenewChanges?: Maybe<Scalars["Boolean"]["output"]>;
  enableCurrencyConverter?: Maybe<Scalars["Boolean"]["output"]>;
  enableReferral?: Maybe<Scalars["Boolean"]["output"]>;
  enableTrustpilot?: Maybe<Scalars["Boolean"]["output"]>;
  enableApplepay?: Maybe<Scalars["Boolean"]["output"]>;
  enableGooglepay?: Maybe<Scalars["Boolean"]["output"]>;
  enableFresApiV2?: Maybe<Scalars["Boolean"]["output"]>;
  enablePayByBank?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["String"]["output"];
  minimumAppVersion: Scalars["String"]["output"];
};

export type CreateAppConfigInput = {
  disableApp: Scalars["Boolean"]["input"];
  disableTI: Scalars["Boolean"]["input"];
  tiStartDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>;
  tiEndDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>;
  tmcStartDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>;
  tmcEndDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>;
  appFuncStartDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>;
  appFuncEndDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>;
  disableTICancellation: Scalars["Boolean"]["input"];
  disableTIPurchase: Scalars["Boolean"]["input"];
  disableTIRenewals: Scalars["Boolean"]["input"];
  disableTMC: Scalars["Boolean"]["input"];
  disabledMessageApp?: InputMaybe<Scalars["String"]["input"]>;
  disabledMessageTI?: InputMaybe<Scalars["String"]["input"]>;
  disabledMessageTICancellation?: InputMaybe<Scalars["String"]["input"]>;
  disabledMessageTIPurchase?: InputMaybe<Scalars["String"]["input"]>;
  disabledMessageTIRenewals?: InputMaybe<Scalars["String"]["input"]>;
  disabledMessageTMC?: InputMaybe<Scalars["String"]["input"]>;
  enableJuneAutorenewChanges?: InputMaybe<Scalars["Boolean"]["input"]>;
  enableCurrencyConverter?: InputMaybe<Scalars["Boolean"]["input"]>;
  enableReferral?: InputMaybe<Scalars["Boolean"]["input"]>;
  enableTrustpilot?: InputMaybe<Scalars["Boolean"]["input"]>;
  enableApplepay?: InputMaybe<Scalars["Boolean"]["input"]>;
  enableGooglepay?: InputMaybe<Scalars["Boolean"]["input"]>;
  enableFresApiV2?: InputMaybe<Scalars["Boolean"]["input"]>;
  enablePayByBank?: InputMaybe<Scalars["Boolean"]["input"]>;
  id: Scalars["String"]["input"];
  minimumAppVersion: Scalars["String"]["input"];
};

export type CreateCurrenciesInput = {
  CurrencyCode: Scalars["String"]["input"];
  CurrencyName: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
};

export type CreateErrorMessagesInput = {
  ErrorDescription?: InputMaybe<Scalars["String"]["input"]>;
  ErrorKey?: InputMaybe<ErrorKeys>;
  ErrorNumber?: InputMaybe<Scalars["Int"]["input"]>;
  InAppErrorMessage?: InputMaybe<InAppErrorMessageTypeInput>;
  id: Scalars["ID"]["input"];
};

export type CreateMessagesInput = {
  Active?: InputMaybe<Scalars["Boolean"]["input"]>;
  Description: Scalars["String"]["input"];
  EndDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>;
  Headline: Scalars["String"]["input"];
  Marketing?: InputMaybe<Scalars["Boolean"]["input"]>;
  MatchAll?: InputMaybe<Scalars["Boolean"]["input"]>;
  Renewals?: InputMaybe<Scalars["Boolean"]["input"]>;
  StartDate: Scalars["AWSDateTime"]["input"];
  Summary?: InputMaybe<Scalars["String"]["input"]>;
  TIUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
  TMCUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
  GuestUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
  LoggedInUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
  AllUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
  HasCTAButton?: InputMaybe<Scalars["Boolean"]["input"]>;
  IsWebLink?: InputMaybe<Scalars["Boolean"]["input"]>;
  WebLinkURL?: InputMaybe<Scalars["String"]["input"]>;
  ButtonLabel?: InputMaybe<Scalars["String"]["input"]>;
  CallToActionText?: InputMaybe<Scalars["String"]["input"]>;
  CallToActionType?: InputMaybe<Scalars["String"]["input"]>;
  CallToActionBtnColor?: Scalars["String"]["input"];
  Title: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
};

export type CreatePolicyInput = {
  body: Scalars["String"]["input"];
  header: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
  isActive: Scalars["Boolean"]["input"];
  policyType: Scalars["String"]["input"];
};

export type CreatePushNotificationInput = {
  application?: InputMaybe<Scalars["String"]["input"]>;
  autoPauseSchedule?: InputMaybe<Scalars["Boolean"]["input"]>;
  body?: InputMaybe<Scalars["String"]["input"]>;
  deeplink?: InputMaybe<Scalars["String"]["input"]>;
  deviceOS?: InputMaybe<Scalars["String"]["input"]>;
  dueOn?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
  pauseSendingTime?: InputMaybe<Scalars["String"]["input"]>;
  resumeSendingTime?: InputMaybe<Scalars["String"]["input"]>;
  scheduleId?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  throttleRate: Scalars["Int"]["input"];
  tiUsers?: InputMaybe<Scalars["String"]["input"]>;
  title: Scalars["String"]["input"];
  tmcUsers?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreatePushNotificationResponse = {
  __typename?: "CreatePushNotificationResponse";
  pushNotification?: Maybe<PushNotification>;
  scheduleResponse?: Maybe<ScheduleResponse>;
};

export type Currencies = {
  __typename?: "Currencies";
  CurrencyCode?: Maybe<Scalars["String"]["output"]>;
  CurrencyName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
};

export type DeletePushNotificationInput = {
  pushNotificationId: Scalars["String"]["input"];
  scheduleId: Scalars["String"]["input"];
};

export enum ErrorKeys {
  Authentication = "Authentication",
  LoginInputemail = "LOGIN_INPUTEMAIL",
  Network = "NETWORK",
  OnbRegistrationsecondstep = "ONB_REGISTRATIONSECONDSTEP",
  PasscodeRegister = "PASSCODE_REGISTER",
  PasscodeUnlock = "PASSCODE_UNLOCK",
  Test = "TEST",
  TmcActivatecardlinksuccess = "TMC_ACTIVATECARDLINKSUCCESS",
  TmcCardoverview = "TMC_CARDOVERVIEW",
  TmcTopupconfirm = "TMC_TOPUPCONFIRM",
  TmcTopup = "TMC_Topup",
}

export type ErrorMessages = {
  __typename?: "ErrorMessages";
  ErrorDescription?: Maybe<Scalars["String"]["output"]>;
  ErrorKey?: Maybe<ErrorKeys>;
  ErrorNumber?: Maybe<Scalars["Int"]["output"]>;
  InAppErrorMessage?: Maybe<InAppErrorMessageType>;
  id: Scalars["ID"]["output"];
};

export type GetPushNotifcationResponse = {
  __typename?: "GetPushNotifcationResponse";
  allSchedules?: Maybe<GetScheduleResponse>;
  pushNotification?: Maybe<Array<Maybe<PushNotification>>>;
};

export type GetScheduleResponse = {
  __typename?: "GetScheduleResponse";
  schedules?: Maybe<Array<Maybe<Schedule>>>;
};

export type InAppErrorMessageType = {
  __typename?: "InAppErrorMessageType";
  body?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type InAppErrorMessageTypeInput = {
  body?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type LogoutResponse = {
  __typename?: "LogoutResponse";
  result?: Maybe<Scalars["Boolean"]["output"]>;
};

export type Messages = {
  __typename?: "Messages";
  Active?: Maybe<Scalars["Boolean"]["output"]>;
  Description: Scalars["String"]["output"];
  EndDate?: Maybe<Scalars["AWSDateTime"]["output"]>;
  Headline: Scalars["String"]["output"];
  Marketing?: Maybe<Scalars["Boolean"]["output"]>;
  MatchAll?: Maybe<Scalars["Boolean"]["output"]>;
  Renewals?: Maybe<Scalars["Boolean"]["output"]>;
  StartDate: Scalars["AWSDateTime"]["output"];
  Summary?: Maybe<Scalars["String"]["output"]>;
  TIUsers?: Maybe<Scalars["Boolean"]["output"]>;
  TMCUsers?: Maybe<Scalars["Boolean"]["output"]>;
  GuestUsers?: Maybe<Scalars["Boolean"]["output"]>;
  LoggedInUsers?: Maybe<Scalars["Boolean"]["output"]>;
  AllUsers?: Maybe<Scalars["Boolean"]["output"]>;
  HasCTAButton?: InputMaybe<Scalars["Boolean"]["input"]>;
  IsWebLink?: InputMaybe<Scalars["Boolean"]["input"]>;
  WebLinkURL?: Maybe<Scalars["String"]["output"]>;
  ButtonLabel?: Maybe<Scalars["String"]["output"]>;
  CallToActionText?: Maybe<Scalars["String"]["output"]>;
  CallToActionType?: Maybe<Scalars["String"]["output"]>;
  CallToActionBtnColor?: Maybe<Scalars["String"]["output"]>;
  Title: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
};

export type Mutation = {
  __typename?: "Mutation";
  createAppConfig?: Maybe<AppConfig>;
  createCurrencies?: Maybe<Currencies>;
  createErrorMessages?: Maybe<ErrorMessages>;
  createMessages?: Maybe<Messages>;
  createPolicy?: Maybe<Policy>;
  createPushNotification?: Maybe<CreatePushNotificationResponse>;
  createSession: Session;
  deleteAppConfig?: Maybe<Scalars["String"]["output"]>;
  deleteCurrencies?: Maybe<Scalars["String"]["output"]>;
  deleteErrorMessages?: Maybe<Scalars["String"]["output"]>;
  deleteMessages?: Maybe<Scalars["String"]["output"]>;
  deletePolicy?: Maybe<Scalars["String"]["output"]>;
  deletePushNotification?: Maybe<Scalars["String"]["output"]>;
  deleteSession: Scalars["Boolean"]["output"];
  logoutUser?: Maybe<LogoutResponse>;
  updateAppConfig?: Maybe<AppConfig>;
  updateCurrencies?: Maybe<Currencies>;
  updateErrorMessages?: Maybe<ErrorMessages>;
  updateMessages?: Maybe<Messages>;
  updatePolicy?: Maybe<Policy>;
  updatePushNotification?: Maybe<PushNotification>;
  updateSession: Session;
};

export type MutationCreateAppConfigArgs = {
  appConfig: CreateAppConfigInput;
};

export type MutationCreateCurrenciesArgs = {
  currency: CreateCurrenciesInput;
};

export type MutationCreateErrorMessagesArgs = {
  errorMessages: CreateErrorMessagesInput;
};

export type MutationCreateMessagesArgs = {
  messages: CreateMessagesInput;
};

export type MutationCreatePolicyArgs = {
  policy: CreatePolicyInput;
};

export type MutationCreatePushNotificationArgs = {
  pushNotification: CreatePushNotificationInput;
};

export type MutationCreateSessionArgs = {
  Token: Scalars["String"]["input"];
  UserName: Scalars["String"]["input"];
};

export type MutationDeleteAppConfigArgs = {
  appConfigId: Scalars["String"]["input"];
};

export type MutationDeleteCurrenciesArgs = {
  currencyId: Scalars["String"]["input"];
};

export type MutationDeleteErrorMessagesArgs = {
  errorMessagesId: Scalars["String"]["input"];
};

export type MutationDeleteMessagesArgs = {
  messagesId: Scalars["String"]["input"];
};

export type MutationDeletePolicyArgs = {
  policyId: Scalars["String"]["input"];
};

export type MutationDeletePushNotificationArgs = {
  deleteID: DeletePushNotificationInput;
};

export type MutationDeleteSessionArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationUpdateAppConfigArgs = {
  appConfig: UpdateAppConfigInput;
};

export type MutationUpdateCurrenciesArgs = {
  currency: UpdateCurrenciesInput;
};

export type MutationUpdateErrorMessagesArgs = {
  errorMessages: UpdateErrorMessagesInput;
};

export type MutationUpdateMessagesArgs = {
  messages: UpdateMessagesInput;
};

export type MutationUpdatePolicyArgs = {
  policy: UpdatePolicyInput;
};

export type MutationUpdatePushNotificationArgs = {
  pushNotification: UpdatePushNotificationInput;
};

export type MutationUpdateSessionArgs = {
  Token?: InputMaybe<Scalars["String"]["input"]>;
  UserName?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
};

export type NotificationMessageType = {
  __typename?: "NotificationMessageType";
  notification?: Maybe<NotificationType>;
};

export type NotificationType = {
  __typename?: "NotificationType";
  body?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type Policy = {
  __typename?: "Policy";
  body: Scalars["String"]["output"];
  header: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  isActive: Scalars["Boolean"]["output"];
  policyType: Scalars["String"]["output"];
};

export type PushNotification = {
  __typename?: "PushNotification";
  application?: Maybe<Scalars["String"]["output"]>;
  autoPauseSchedule?: Maybe<Scalars["Boolean"]["output"]>;
  body?: Maybe<Scalars["String"]["output"]>;
  deeplink?: Maybe<Scalars["String"]["output"]>;
  deviceOS?: Maybe<Scalars["String"]["output"]>;
  dueOn?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  pauseSendingTime?: Maybe<Scalars["String"]["output"]>;
  resumeSendingTime?: Maybe<Scalars["String"]["output"]>;
  scheduleId?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  throttleRate: Scalars["Int"]["output"];
  tiUsers?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  tmcUsers?: Maybe<Scalars["String"]["output"]>;
};

export type Query = {
  __typename?: "Query";
  getAppConfig?: Maybe<Array<Maybe<AppConfig>>>;
  getAppConfigById?: Maybe<AppConfig>;
  getCurrencies?: Maybe<Array<Maybe<Currencies>>>;
  getCurrenciesById?: Maybe<Currencies>;
  getErrorMessages?: Maybe<Array<Maybe<ErrorMessages>>>;
  getErrorMessagesById?: Maybe<ErrorMessages>;
  getMessages?: Maybe<Array<Maybe<Messages>>>;
  getMessagesById?: Maybe<Messages>;
  getPolicy?: Maybe<Array<Maybe<Policy>>>;
  getPolicyById?: Maybe<Policy>;
  getPushNotification?: Maybe<GetPushNotifcationResponse>;
  getPushNotificationById?: Maybe<PushNotification>;
  getSession?: Maybe<Session>;
  sessions: Array<Session>;
};

export type QueryGetAppConfigByIdArgs = {
  appConfigId: Scalars["String"]["input"];
};

export type QueryGetCurrenciesByIdArgs = {
  currencyId: Scalars["String"]["input"];
};

export type QueryGetErrorMessagesByIdArgs = {
  errorMessagesId: Scalars["String"]["input"];
};

export type QueryGetMessagesByIdArgs = {
  messagesId: Scalars["String"]["input"];
};

export type QueryGetPolicyByIdArgs = {
  policyId: Scalars["String"]["input"];
};

export type QueryGetPushNotificationByIdArgs = {
  pushNotificationId: Scalars["String"]["input"];
};

export type QueryGetSessionArgs = {
  id: Scalars["ID"]["input"];
};

export type Schedule = {
  __typename?: "Schedule";
  appName?: Maybe<Scalars["String"]["output"]>;
  completedOn?: Maybe<Scalars["String"]["output"]>;
  createdOn?: Maybe<Scalars["String"]["output"]>;
  deviceAttr?: Maybe<Scalars["String"]["output"]>;
  dueOn?: Maybe<Scalars["String"]["output"]>;
  notificationMsg?: Maybe<NotificationMessageType>;
  notificationName?: Maybe<Scalars["String"]["output"]>;
  numFailure?: Maybe<Scalars["Int"]["output"]>;
  numOptedOut?: Maybe<Scalars["Int"]["output"]>;
  numSuccess?: Maybe<Scalars["Int"]["output"]>;
  pauseSendingTime?: Maybe<Scalars["String"]["output"]>;
  resumeSendingTime?: Maybe<Scalars["String"]["output"]>;
  scheduleId?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  subscriptions?: Maybe<SubscriptionType>;
  throttleRate?: Maybe<Scalars["Int"]["output"]>;
  updatedOn?: Maybe<Scalars["String"]["output"]>;
};

export type ScheduleResponse = {
  __typename?: "ScheduleResponse";
  message?: Maybe<Scalars["String"]["output"]>;
  scheduleId?: Maybe<Scalars["Int"]["output"]>;
};

export type Session = {
  __typename?: "Session";
  hashedEmail: Scalars["String"]["output"];
  uuid: Scalars["ID"]["output"];
};

export type SubscriptionType = {
  __typename?: "SubscriptionType";
  tiUsers?: Maybe<Scalars["Boolean"]["output"]>;
  tmcUsers?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UpdateAppConfigInput = {
  disableApp: Scalars["Boolean"]["input"];
  disableTI: Scalars["Boolean"]["input"];
  tiStartDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>;
  tiEndDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>;
  tmcStartDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>;
  tmcEndDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>;
  appFuncStartDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>;
  appFuncEndDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>;
  disableTICancellation: Scalars["Boolean"]["input"];
  disableTIPurchase: Scalars["Boolean"]["input"];
  disableTIRenewals: Scalars["Boolean"]["input"];
  disableTMC: Scalars["Boolean"]["input"];
  disabledMessageApp?: InputMaybe<Scalars["String"]["input"]>;
  disabledMessageTI?: InputMaybe<Scalars["String"]["input"]>;
  disabledMessageTICancellation?: InputMaybe<Scalars["String"]["input"]>;
  disabledMessageTIPurchase?: InputMaybe<Scalars["String"]["input"]>;
  disabledMessageTIRenewals?: InputMaybe<Scalars["String"]["input"]>;
  disabledMessageTMC?: InputMaybe<Scalars["String"]["input"]>;
  enableJuneAutorenewChanges?: InputMaybe<Scalars["Boolean"]["input"]>;
  enableCurrencyConverter?: InputMaybe<Scalars["Boolean"]["input"]>;
  enableReferral?: InputMaybe<Scalars["Boolean"]["input"]>;
  enableTrustpilot?: InputMaybe<Scalars["Boolean"]["input"]>;
  enableApplepay?: InputMaybe<Scalars["Boolean"]["input"]>;
  enableGooglepay?: InputMaybe<Scalars["Boolean"]["input"]>;
  enableFresApiV2?: InputMaybe<Scalars["Boolean"]["input"]>;
  enablePayByBank?: InputMaybe<Scalars["Boolean"]["input"]>;
  id: Scalars["String"]["input"];
  minimumAppVersion: Scalars["String"]["input"];
};

export type UpdateCurrenciesInput = {
  CurrencyCode: Scalars["String"]["input"];
  CurrencyName: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
};

export type UpdateErrorMessagesInput = {
  ErrorDescription?: InputMaybe<Scalars["String"]["input"]>;
  ErrorKey?: InputMaybe<ErrorKeys>;
  ErrorNumber?: InputMaybe<Scalars["Int"]["input"]>;
  InAppErrorMessage?: InputMaybe<InAppErrorMessageTypeInput>;
  id: Scalars["ID"]["input"];
};

export type UpdateMessagesInput = {
  Active?: InputMaybe<Scalars["Boolean"]["input"]>;
  Description: Scalars["String"]["input"];
  EndDate?: InputMaybe<Scalars["AWSDateTime"]["input"]>;
  Headline: Scalars["String"]["input"];
  Marketing?: InputMaybe<Scalars["Boolean"]["input"]>;
  MatchAll?: InputMaybe<Scalars["Boolean"]["input"]>;
  Renewals?: InputMaybe<Scalars["Boolean"]["input"]>;
  StartDate: Scalars["AWSDateTime"]["input"];
  Summary?: InputMaybe<Scalars["String"]["input"]>;
  TIUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
  TMCUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
  GuestUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
  LoggedInUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
  AllUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
  HasCTAButton?: InputMaybe<Scalars["Boolean"]["input"]>;
  IsWebLink?: InputMaybe<Scalars["Boolean"]["input"]>;
  WebLinkURL?: InputMaybe<Scalars["String"]["input"]>;
  ButtonLabel?: InputMaybe<Scalars["String"]["input"]>;
  CallToActionText?: InputMaybe<Scalars["String"]["input"]>;
  CallToActionType?: InputMaybe<Scalars["String"]["input"]>;
  CallToActionBtnColor?: Scalars["String"]["input"];
  Title: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
};

export type UpdatePolicyInput = {
  body: Scalars["String"]["input"];
  header: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
  isActive: Scalars["Boolean"]["input"];
  policyType: Scalars["String"]["input"];
};

export type UpdatePushNotificationInput = {
  application?: InputMaybe<Scalars["String"]["input"]>;
  autoPauseSchedule?: InputMaybe<Scalars["Boolean"]["input"]>;
  body?: InputMaybe<Scalars["String"]["input"]>;
  deeplink?: InputMaybe<Scalars["String"]["input"]>;
  deviceOS?: InputMaybe<Scalars["String"]["input"]>;
  dueOn?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
  pauseSendingTime?: InputMaybe<Scalars["String"]["input"]>;
  resumeSendingTime?: InputMaybe<Scalars["String"]["input"]>;
  scheduleId?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  throttleRate: Scalars["Int"]["input"];
  tiUsers?: InputMaybe<Scalars["String"]["input"]>;
  title: Scalars["String"]["input"];
  tmcUsers?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateAppConfigMutationVariables = Exact<{
  appConfig: CreateAppConfigInput;
}>;

export type CreateAppConfigMutation = {
  __typename?: "Mutation";
  createAppConfig?: {
    __typename?: "AppConfig";
    id: string;
    minimumAppVersion: string;
    disableTMC: boolean;
    disableTI: boolean;
    tiStartDate?: any;
    tiEndDate?: any;
    tmcStartDate?: any;
    tmcEndDate?: any;
    appFuncStartDate?: any;
    appFuncEndDate?: any;
    disableApp: boolean;
    disableTIPurchase: boolean;
    disableTICancellation: boolean;
    disableTIRenewals: boolean;
    disabledMessageTMC?: string | null;
    disabledMessageTI?: string | null;
    disabledMessageApp?: string | null;
    disabledMessageTIPurchase?: string | null;
    disabledMessageTICancellation?: string | null;
    disabledMessageTIRenewals?: string | null;
    enableJuneAutorenewChanges?: boolean | null;
    enableCurrencyConverter?: boolean | null;
    enableReferral?: boolean | null;
    enableTrustpilot?: boolean | null;
    enableApplepay?: boolean | null;
    enableGooglepay?: boolean | null;
    enableFresApiV2?: boolean | null;
    enablePayByBank?: boolean | null;
  } | null;
};

export type DeleteAppConfigMutationVariables = Exact<{
  appConfigId: Scalars["String"]["input"];
}>;

export type DeleteAppConfigMutation = {
  __typename?: "Mutation";
  deleteAppConfig?: string | null;
};

export type GetAppConfigQueryVariables = Exact<{ [key: string]: never }>;

export type GetAppConfigQuery = {
  __typename?: "Query";
  getAppConfig?: Array<{
    __typename?: "AppConfig";
    id: string;
    minimumAppVersion: string;
    disableTMC: boolean;
    disableTI: boolean;
    tiStartDate?: any;
    tiEndDate?: any;
    tmcStartDate?: any;
    tmcEndDate?: any;
    appFuncStartDate?: any;
    appFuncEndDate?: any;
    disableApp: boolean;
    disableTIPurchase: boolean;
    disableTICancellation: boolean;
    disableTIRenewals: boolean;
    disabledMessageTMC?: string | null;
    disabledMessageTI?: string | null;
    disabledMessageApp?: string | null;
    disabledMessageTIPurchase?: string | null;
    disabledMessageTICancellation?: string | null;
    disabledMessageTIRenewals?: string | null;
    enableJuneAutorenewChanges?: boolean | null;
    enableCurrencyConverter?: boolean | null;
    enableReferral?: boolean | null;
    enableTrustpilot?: boolean | null;
    enableApplepay?: boolean | null;
    enableGooglepay?: boolean | null;
    enableFresApiV2?: boolean | null;
    enablePayByBank?: boolean | null;
  } | null> | null;
};

export type GetAppConfigByIdQueryVariables = Exact<{
  appConfigId: Scalars["String"]["input"];
}>;

export type GetAppConfigByIdQuery = {
  __typename?: "Query";
  getAppConfigById?: {
    __typename?: "AppConfig";
    id: string;
    minimumAppVersion: string;
    disableTMC: boolean;
    disableTI: boolean;
    tiStartDate?: any;
    tiEndDate?: any;
    tmcStartDate?: any;
    tmcEndDate?: any;
    appFuncStartDate?: any;
    appFuncEndDate?: any;
    disableApp: boolean;
    disableTIPurchase: boolean;
    disableTICancellation: boolean;
    disableTIRenewals: boolean;
    disabledMessageTMC?: string | null;
    disabledMessageTI?: string | null;
    disabledMessageApp?: string | null;
    disabledMessageTIPurchase?: string | null;
    disabledMessageTICancellation?: string | null;
    disabledMessageTIRenewals?: string | null;
    enableJuneAutorenewChanges?: boolean | null;
    enableCurrencyConverter?: boolean | null;
    enableReferral?: boolean | null;
    enableTrustpilot?: boolean | null;
    enableApplepay?: boolean | null;
    enableGooglepay?: boolean | null;
    enableFresApiV2?: boolean | null;
    enablePayByBank?: boolean | null;
  } | null;
};

export type UpdateAppConfigMutationVariables = Exact<{
  appConfig: UpdateAppConfigInput;
}>;

export type UpdateAppConfigMutation = {
  __typename?: "Mutation";
  updateAppConfig?: {
    __typename?: "AppConfig";
    id: string;
    minimumAppVersion: string;
    disableTMC: boolean;
    disableTI: boolean;
    tiStartDate?: any;
    tiEndDate?: any;
    tmcStartDate?: any;
    tmcEndDate?: any;
    appFuncStartDate?: any;
    appFuncEndDate?: any;
    disableApp: boolean;
    disableTIPurchase: boolean;
    disableTICancellation: boolean;
    disableTIRenewals: boolean;
    disabledMessageTMC?: string | null;
    disabledMessageTI?: string | null;
    disabledMessageApp?: string | null;
    disabledMessageTIPurchase?: string | null;
    disabledMessageTICancellation?: string | null;
    disabledMessageTIRenewals?: string | null;
    enableJuneAutorenewChanges?: boolean | null;
    enableCurrencyConverter?: boolean | null;
    enableReferral?: boolean | null;
    enableTrustpilot?: boolean | null;
    enableApplepay?: boolean | null;
    enableGooglepay?: boolean | null;
    enableFresApiV2?: boolean | null;
    enablePayByBank?: boolean | null;
  } | null;
};

export type CreateCurrenciesMutationVariables = Exact<{
  currency: CreateCurrenciesInput;
}>;

export type CreateCurrenciesMutation = {
  __typename?: "Mutation";
  createCurrencies?: {
    __typename?: "Currencies";
    CurrencyCode?: string | null;
    CurrencyName?: string | null;
    id: string;
  } | null;
};

export type DeleteCurrenciesMutationVariables = Exact<{
  currencyId: Scalars["String"]["input"];
}>;

export type DeleteCurrenciesMutation = {
  __typename?: "Mutation";
  deleteCurrencies?: string | null;
};

export type GetCurrenciesQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrenciesQuery = {
  __typename?: "Query";
  getCurrencies?: Array<{
    __typename?: "Currencies";
    CurrencyCode?: string | null;
    CurrencyName?: string | null;
    id: string;
  } | null> | null;
};

export type GetCurrenciesByIdQueryVariables = Exact<{
  currencyId: Scalars["String"]["input"];
}>;

export type GetCurrenciesByIdQuery = {
  __typename?: "Query";
  getCurrenciesById?: {
    __typename?: "Currencies";
    CurrencyCode?: string | null;
    CurrencyName?: string | null;
    id: string;
  } | null;
};

export type UpdateCurrenciesMutationVariables = Exact<{
  currency: UpdateCurrenciesInput;
}>;

export type UpdateCurrenciesMutation = {
  __typename?: "Mutation";
  updateCurrencies?: {
    __typename?: "Currencies";
    CurrencyCode?: string | null;
    CurrencyName?: string | null;
    id: string;
  } | null;
};

export type CreateErrorMessagesMutationVariables = Exact<{
  errorMessages: CreateErrorMessagesInput;
}>;

export type CreateErrorMessagesMutation = {
  __typename?: "Mutation";
  createErrorMessages?: {
    __typename?: "ErrorMessages";
    id: string;
    ErrorKey?: ErrorKeys | null;
    ErrorNumber?: number | null;
    ErrorDescription?: string | null;
    InAppErrorMessage?: {
      __typename?: "InAppErrorMessageType";
      title?: string | null;
      body?: string | null;
    } | null;
  } | null;
};

export type DeleteErrorMessagesMutationVariables = Exact<{
  errorMessagesId: Scalars["String"]["input"];
}>;

export type DeleteErrorMessagesMutation = {
  __typename?: "Mutation";
  deleteErrorMessages?: string | null;
};

export type GetErrorMessagesQueryVariables = Exact<{ [key: string]: never }>;

export type GetErrorMessagesQuery = {
  __typename?: "Query";
  getErrorMessages?: Array<{
    __typename?: "ErrorMessages";
    id: string;
    ErrorKey?: ErrorKeys | null;
    ErrorNumber?: number | null;
    ErrorDescription?: string | null;
    InAppErrorMessage?: {
      __typename?: "InAppErrorMessageType";
      title?: string | null;
      body?: string | null;
    } | null;
  } | null> | null;
};

export type GetErrorMessagesByIdQueryVariables = Exact<{
  errorMessagesId: Scalars["String"]["input"];
}>;

export type GetErrorMessagesByIdQuery = {
  __typename?: "Query";
  getErrorMessagesById?: {
    __typename?: "ErrorMessages";
    id: string;
    ErrorKey?: ErrorKeys | null;
    ErrorNumber?: number | null;
    ErrorDescription?: string | null;
    InAppErrorMessage?: {
      __typename?: "InAppErrorMessageType";
      title?: string | null;
      body?: string | null;
    } | null;
  } | null;
};

export type UpdateErrorMessagesMutationVariables = Exact<{
  errorMessages: UpdateErrorMessagesInput;
}>;

export type UpdateErrorMessagesMutation = {
  __typename?: "Mutation";
  updateErrorMessages?: {
    __typename?: "ErrorMessages";
    id: string;
    ErrorKey?: ErrorKeys | null;
    ErrorNumber?: number | null;
    ErrorDescription?: string | null;
    InAppErrorMessage?: {
      __typename?: "InAppErrorMessageType";
      title?: string | null;
      body?: string | null;
    } | null;
  } | null;
};

export type LogoutUserMutationVariables = Exact<{ [key: string]: never }>;

export type LogoutUserMutation = {
  __typename?: "Mutation";
  logoutUser?: {
    __typename?: "LogoutResponse";
    result?: boolean | null;
  } | null;
};

export type CreateMessagesMutationVariables = Exact<{
  messages: CreateMessagesInput;
}>;

export type CreateMessagesMutation = {
  __typename?: "Mutation";
  createMessages?: {
    __typename?: "Messages";
    id: string;
    Title: string;
    Headline: string;
    Summary?: string | null;
    Description: string;
    StartDate: any;
    EndDate?: any | null;
    Active?: boolean | null;
    TMCUsers?: boolean | null;
    TIUsers?: boolean | null;
    Renewals?: boolean | null;
    GuestUsers?: boolean | null;
    LoggedInUsers?: boolean | null;
    AllUsers?: boolean | null;
    Marketing?: boolean | null;
    MatchAll?: boolean | null;
    HasCTAButton?: boolean | null;
    IsWebLink?: boolean | null;
    WebLinkURL?: string | null;
    ButtonLabel?: string | null;
    CallToActionText?: string | null;
    CallToActionType?: string | null;
    CallToActionBtnColor?: string;
  } | null;
};

export type DeleteMessagesMutationVariables = Exact<{
  messagesId: Scalars["String"]["input"];
}>;

export type DeleteMessagesMutation = {
  __typename?: "Mutation";
  deleteMessages?: string | null;
};

export type GetMessagesQueryVariables = Exact<{ [key: string]: never }>;

export type GetMessagesQuery = {
  __typename?: "Query";
  getMessages?: Array<{
    __typename?: "Messages";
    id: string;
    Title: string;
    Headline: string;
    Summary?: string | null;
    Description: string;
    StartDate: any;
    EndDate?: any | null;
    Active?: boolean | null;
    TMCUsers?: boolean | null;
    TIUsers?: boolean | null;
    Renewals?: boolean | null;
    GuestUsers?: boolean | null;
    LoggedInUsers?: boolean | null;
    AllUsers?: boolean | null;
    Marketing?: boolean | null;
    MatchAll?: boolean | null;
    HasCTAButton?: boolean | null;
    IsWebLink?: boolean | null;
    WebLinkURL?: string | null;
    ButtonLabel?: string | null;
    CallToActionText?: string | null;
    CallToActionType?: string | null;
    CallToActionBtnColor?: string | null;
  } | null> | null;
};

export type GetMessagesByIdQueryVariables = Exact<{
  messagesId: Scalars["String"]["input"];
}>;

export type GetMessagesByIdQuery = {
  __typename?: "Query";
  getMessagesById?: {
    __typename?: "Messages";
    id: string;
    Title: string;
    Headline: string;
    Summary?: string | null;
    Description: string;
    StartDate: any;
    EndDate?: any | null;
    Active?: boolean | null;
    TMCUsers?: boolean | null;
    TIUsers?: boolean | null;
    Renewals?: boolean | null;
    GuestUsers?: boolean | null;
    LoggedInUsers?: boolean | null;
    AllUsers?: boolean | null;
    Marketing?: boolean | null;
    MatchAll?: boolean | null;
    HasCTAButton?: boolean | null;
    IsWebLink?: boolean | null;
    WebLinkURL?: string | null;
    ButtonLabel?: string | null;
    CallToActionText?: string | null;
    CallToActionType?: string | null;
    CallToActionBtnColor?: string | null;
  } | null;
};

export type UpdateMessagesMutationVariables = Exact<{
  messages: UpdateMessagesInput;
}>;

export type UpdateMessagesMutation = {
  __typename?: "Mutation";
  updateMessages?: {
    __typename?: "Messages";
    id: string;
    Title: string;
    Headline: string;
    Summary?: string | null;
    Description: string;
    StartDate: any;
    EndDate?: any | null;
    Active?: boolean | null;
    TMCUsers?: boolean | null;
    TIUsers?: boolean | null;
    Renewals?: boolean | null;
    GuestUsers?: boolean | null;
    LoggedInUsers?: boolean | null;
    AllUsers?: boolean | null;
    Marketing?: boolean | null;
    MatchAll?: boolean | null;
    HasCTAButton?: boolean | null;
    IsWebLink?: boolean | null;
    WebLinkURL?: string | null;
    ButtonLabel?: string | null;
    CallToActionText?: string | null;
    CallToActionType?: string | null;
    CallToActionBtnColor?: string;
  } | null;
};

export type CreatePolicyMutationVariables = Exact<{
  policy: CreatePolicyInput;
}>;

export type CreatePolicyMutation = {
  __typename?: "Mutation";
  createPolicy?: {
    __typename?: "Policy";
    id: string;
    policyType: string;
    header: string;
    body: string;
    isActive: boolean;
  } | null;
};

export type DeletePolicyMutationVariables = Exact<{
  policyId: Scalars["String"]["input"];
}>;

export type DeletePolicyMutation = {
  __typename?: "Mutation";
  deletePolicy?: string | null;
};

export type GetPolicyQueryVariables = Exact<{ [key: string]: never }>;

export type GetPolicyQuery = {
  __typename?: "Query";
  getPolicy?: Array<{
    __typename?: "Policy";
    id: string;
    policyType: string;
    header: string;
    body: string;
    isActive: boolean;
  } | null> | null;
};

export type GetPolicyByIdQueryVariables = Exact<{
  policyId: Scalars["String"]["input"];
}>;

export type GetPolicyByIdQuery = {
  __typename?: "Query";
  getPolicyById?: {
    __typename?: "Policy";
    id: string;
    policyType: string;
    header: string;
    body: string;
    isActive: boolean;
  } | null;
};

export type UpdatePolicyMutationVariables = Exact<{
  policy: UpdatePolicyInput;
}>;

export type UpdatePolicyMutation = {
  __typename?: "Mutation";
  updatePolicy?: {
    __typename?: "Policy";
    id: string;
    policyType: string;
    header: string;
    body: string;
    isActive: boolean;
  } | null;
};

export type CreatePushNotificationMutationVariables = Exact<{
  pushNotification: CreatePushNotificationInput;
}>;

export type CreatePushNotificationMutation = {
  __typename?: "Mutation";
  createPushNotification?: {
    __typename?: "CreatePushNotificationResponse";
    pushNotification?: {
      __typename?: "PushNotification";
      id: string;
      name: string;
      title: string;
      scheduleId?: number | null;
      body?: string | null;
      deeplink?: string | null;
      dueOn?: string | null;
      throttleRate: number;
      autoPauseSchedule?: boolean | null;
      pauseSendingTime?: string | null;
      resumeSendingTime?: string | null;
      application?: string | null;
      tmcUsers?: string | null;
      tiUsers?: string | null;
      deviceOS?: string | null;
      status?: string | null;
    } | null;
    scheduleResponse?: {
      __typename?: "ScheduleResponse";
      scheduleId?: number | null;
      message?: string | null;
    } | null;
  } | null;
};

export type DeletePushNotificationMutationVariables = Exact<{
  deleteID: DeletePushNotificationInput;
}>;

export type DeletePushNotificationMutation = {
  __typename?: "Mutation";
  deletePushNotification?: string | null;
};

export type GetPushNotificationQueryVariables = Exact<{ [key: string]: never }>;

export type GetPushNotificationQuery = {
  __typename?: "Query";
  getPushNotification?: {
    __typename?: "GetPushNotifcationResponse";
    pushNotification?: Array<{
      __typename?: "PushNotification";
      id: string;
      name: string;
      title: string;
      scheduleId?: number | null;
      body?: string | null;
      deeplink?: string | null;
      dueOn?: string | null;
      throttleRate: number;
      autoPauseSchedule?: boolean | null;
      pauseSendingTime?: string | null;
      resumeSendingTime?: string | null;
      application?: string | null;
      tmcUsers?: string | null;
      tiUsers?: string | null;
      deviceOS?: string | null;
      status?: string | null;
    } | null> | null;
    allSchedules?: {
      __typename?: "GetScheduleResponse";
      schedules?: Array<{
        __typename?: "Schedule";
        scheduleId?: number | null;
        appName?: string | null;
        notificationName?: string | null;
        deviceAttr?: string | null;
        createdOn?: string | null;
        updatedOn?: string | null;
        dueOn?: string | null;
        completedOn?: string | null;
        status?: string | null;
        numOptedOut?: number | null;
        numSuccess?: number | null;
        numFailure?: number | null;
        throttleRate?: number | null;
        pauseSendingTime?: string | null;
        resumeSendingTime?: string | null;
        notificationMsg?: {
          __typename?: "NotificationMessageType";
          notification?: {
            __typename?: "NotificationType";
            title?: string | null;
            body?: string | null;
          } | null;
        } | null;
        subscriptions?: {
          __typename?: "SubscriptionType";
          tmcUsers?: boolean | null;
          tiUsers?: boolean | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type GetPushNotificationByIdQueryVariables = Exact<{
  pushNotificationId: Scalars["String"]["input"];
}>;

export type GetPushNotificationByIdQuery = {
  __typename?: "Query";
  getPushNotificationById?: {
    __typename?: "PushNotification";
    id: string;
    name: string;
    title: string;
    scheduleId?: number | null;
    body?: string | null;
    deeplink?: string | null;
    dueOn?: string | null;
    throttleRate: number;
    autoPauseSchedule?: boolean | null;
    pauseSendingTime?: string | null;
    resumeSendingTime?: string | null;
    application?: string | null;
    tmcUsers?: string | null;
    tiUsers?: string | null;
    deviceOS?: string | null;
    status?: string | null;
  } | null;
};

export type UpdatePushNotificationMutationVariables = Exact<{
  pushNotification: UpdatePushNotificationInput;
}>;

export type UpdatePushNotificationMutation = {
  __typename?: "Mutation";
  updatePushNotification?: {
    __typename?: "PushNotification";
    id: string;
    name: string;
    title: string;
    scheduleId?: number | null;
    body?: string | null;
    deeplink?: string | null;
    dueOn?: string | null;
    throttleRate: number;
    autoPauseSchedule?: boolean | null;
    pauseSendingTime?: string | null;
    resumeSendingTime?: string | null;
    application?: string | null;
    tmcUsers?: string | null;
    tiUsers?: string | null;
    deviceOS?: string | null;
    status?: string | null;
  } | null;
};

export type CreateSessionMutationVariables = Exact<{
  UserName: Scalars["String"]["input"];
  Token: Scalars["String"]["input"];
}>;

export type CreateSessionMutation = {
  __typename?: "Mutation";
  createSession: { __typename?: "Session"; uuid: string; hashedEmail: string };
};

export type DeleteSessionMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteSessionMutation = {
  __typename?: "Mutation";
  deleteSession: boolean;
};

export type GetSessionQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type GetSessionQuery = {
  __typename?: "Query";
  getSession?: {
    __typename?: "Session";
    uuid: string;
    hashedEmail: string;
  } | null;
};

export type SessionsQueryVariables = Exact<{ [key: string]: never }>;

export type SessionsQuery = {
  __typename?: "Query";
  sessions: Array<{
    __typename?: "Session";
    uuid: string;
    hashedEmail: string;
  }>;
};

export type UpdateSessionMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  UserName: Scalars["String"]["input"];
  Token: Scalars["String"]["input"];
}>;

export type UpdateSessionMutation = {
  __typename?: "Mutation";
  updateSession: { __typename?: "Session"; uuid: string; hashedEmail: string };
};

export const CreateAppConfigDocument = gql`
  mutation CreateAppConfig($appConfig: CreateAppConfigInput!) {
    createAppConfig(appConfig: $appConfig) {
      id
      minimumAppVersion
      disableTMC
      disableTI
      tiStartDate
      tiEndDate
      tmcStartDate
      tmcEndDate
      appFuncStartDate
      appFuncEndDate
      disableApp
      disableTIPurchase
      disableTICancellation
      disableTIRenewals
      disabledMessageTMC
      disabledMessageTI
      disabledMessageApp
      disabledMessageTIPurchase
      disabledMessageTICancellation
      disabledMessageTIRenewals
      enableJuneAutorenewChanges
      enableCurrencyConverter
      enableReferral
      enableTrustpilot
      enableApplepay
      enableGooglepay
      enableFresApiV2
      enablePayByBank
    }
  }
`;
export type CreateAppConfigMutationFn = Apollo.MutationFunction<
  CreateAppConfigMutation,
  CreateAppConfigMutationVariables
>;

/**
 * __useCreateAppConfigMutation__
 *
 * To run a mutation, you first call `useCreateAppConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppConfigMutation, { data, loading, error }] = useCreateAppConfigMutation({
 *   variables: {
 *      appConfig: // value for 'appConfig'
 *   },
 * });
 */
export function useCreateAppConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAppConfigMutation,
    CreateAppConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAppConfigMutation,
    CreateAppConfigMutationVariables
  >(CreateAppConfigDocument, options);
}
export type CreateAppConfigMutationHookResult = ReturnType<
  typeof useCreateAppConfigMutation
>;
export type CreateAppConfigMutationResult =
  Apollo.MutationResult<CreateAppConfigMutation>;
export type CreateAppConfigMutationOptions = Apollo.BaseMutationOptions<
  CreateAppConfigMutation,
  CreateAppConfigMutationVariables
>;
export const DeleteAppConfigDocument = gql`
  mutation DeleteAppConfig($appConfigId: String!) {
    deleteAppConfig(appConfigId: $appConfigId)
  }
`;
export type DeleteAppConfigMutationFn = Apollo.MutationFunction<
  DeleteAppConfigMutation,
  DeleteAppConfigMutationVariables
>;

/**
 * __useDeleteAppConfigMutation__
 *
 * To run a mutation, you first call `useDeleteAppConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAppConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAppConfigMutation, { data, loading, error }] = useDeleteAppConfigMutation({
 *   variables: {
 *      appConfigId: // value for 'appConfigId'
 *   },
 * });
 */
export function useDeleteAppConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAppConfigMutation,
    DeleteAppConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteAppConfigMutation,
    DeleteAppConfigMutationVariables
  >(DeleteAppConfigDocument, options);
}
export type DeleteAppConfigMutationHookResult = ReturnType<
  typeof useDeleteAppConfigMutation
>;
export type DeleteAppConfigMutationResult =
  Apollo.MutationResult<DeleteAppConfigMutation>;
export type DeleteAppConfigMutationOptions = Apollo.BaseMutationOptions<
  DeleteAppConfigMutation,
  DeleteAppConfigMutationVariables
>;
export const GetAppConfigDocument = gql`
  query GetAppConfig {
    getAppConfig {
      id
      minimumAppVersion
      disableTMC
      disableTI
      tiStartDate
      tiEndDate
      tmcStartDate
      tmcEndDate
      appFuncStartDate
      appFuncEndDate
      disableApp
      disableTIPurchase
      disableTICancellation
      disableTIRenewals
      disabledMessageTMC
      disabledMessageTI
      disabledMessageApp
      disabledMessageTIPurchase
      disabledMessageTICancellation
      disabledMessageTIRenewals
      enableJuneAutorenewChanges
      enableCurrencyConverter
      enableReferral
      enableTrustpilot
      enableApplepay
      enableGooglepay
      enableFresApiV2
      enablePayByBank
    }
  }
`;

/**
 * __useGetAppConfigQuery__
 *
 * To run a query within a React component, call `useGetAppConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAppConfigQuery,
    GetAppConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAppConfigQuery, GetAppConfigQueryVariables>(
    GetAppConfigDocument,
    options,
  );
}
export function useGetAppConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAppConfigQuery,
    GetAppConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAppConfigQuery, GetAppConfigQueryVariables>(
    GetAppConfigDocument,
    options,
  );
}
export function useGetAppConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAppConfigQuery,
        GetAppConfigQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAppConfigQuery, GetAppConfigQueryVariables>(
    GetAppConfigDocument,
    options,
  );
}
export type GetAppConfigQueryHookResult = ReturnType<
  typeof useGetAppConfigQuery
>;
export type GetAppConfigLazyQueryHookResult = ReturnType<
  typeof useGetAppConfigLazyQuery
>;
export type GetAppConfigSuspenseQueryHookResult = ReturnType<
  typeof useGetAppConfigSuspenseQuery
>;
export type GetAppConfigQueryResult = Apollo.QueryResult<
  GetAppConfigQuery,
  GetAppConfigQueryVariables
>;
export const GetAppConfigByIdDocument = gql`
  query GetAppConfigById($appConfigId: String!) {
    getAppConfigById(appConfigId: $appConfigId) {
      id
      minimumAppVersion
      disableTMC
      disableTI
      tiStartDate
      tiEndDate
      tmcStartDate
      tmcEndDate
      appFuncStartDate
      appFuncEndDate
      disableApp
      disableTIPurchase
      disableTICancellation
      disableTIRenewals
      disabledMessageTMC
      disabledMessageTI
      disabledMessageApp
      disabledMessageTIPurchase
      disabledMessageTICancellation
      disabledMessageTIRenewals
      enableJuneAutorenewChanges
      enableCurrencyConverter
      enableReferral
      enableTrustpilot
      enableApplepay
      enableGooglepay
      enableFresApiV2
      enablePayByBank
    }
  }
`;

/**
 * __useGetAppConfigByIdQuery__
 *
 * To run a query within a React component, call `useGetAppConfigByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppConfigByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppConfigByIdQuery({
 *   variables: {
 *      appConfigId: // value for 'appConfigId'
 *   },
 * });
 */
export function useGetAppConfigByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAppConfigByIdQuery,
    GetAppConfigByIdQueryVariables
  > &
    (
      | { variables: GetAppConfigByIdQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAppConfigByIdQuery, GetAppConfigByIdQueryVariables>(
    GetAppConfigByIdDocument,
    options,
  );
}
export function useGetAppConfigByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAppConfigByIdQuery,
    GetAppConfigByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAppConfigByIdQuery,
    GetAppConfigByIdQueryVariables
  >(GetAppConfigByIdDocument, options);
}
export function useGetAppConfigByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAppConfigByIdQuery,
        GetAppConfigByIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAppConfigByIdQuery,
    GetAppConfigByIdQueryVariables
  >(GetAppConfigByIdDocument, options);
}
export type GetAppConfigByIdQueryHookResult = ReturnType<
  typeof useGetAppConfigByIdQuery
>;
export type GetAppConfigByIdLazyQueryHookResult = ReturnType<
  typeof useGetAppConfigByIdLazyQuery
>;
export type GetAppConfigByIdSuspenseQueryHookResult = ReturnType<
  typeof useGetAppConfigByIdSuspenseQuery
>;
export type GetAppConfigByIdQueryResult = Apollo.QueryResult<
  GetAppConfigByIdQuery,
  GetAppConfigByIdQueryVariables
>;
export const UpdateAppConfigDocument = gql`
  mutation UpdateAppConfig($appConfig: UpdateAppConfigInput!) {
    updateAppConfig(appConfig: $appConfig) {
      id
      minimumAppVersion
      disableTMC
      disableTI
      tiStartDate
      tiEndDate
      tmcStartDate
      tmcEndDate
      appFuncStartDate
      appFuncEndDate
      disableApp
      disableTIPurchase
      disableTICancellation
      disableTIRenewals
      disabledMessageTMC
      disabledMessageTI
      disabledMessageApp
      disabledMessageTIPurchase
      disabledMessageTICancellation
      disabledMessageTIRenewals
      enableJuneAutorenewChanges
      enableCurrencyConverter
      enableReferral
      enableTrustpilot
      enableApplepay
      enableGooglepay
      enableFresApiV2
      enablePayByBank
    }
  }
`;
export type UpdateAppConfigMutationFn = Apollo.MutationFunction<
  UpdateAppConfigMutation,
  UpdateAppConfigMutationVariables
>;

/**
 * __useUpdateAppConfigMutation__
 *
 * To run a mutation, you first call `useUpdateAppConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppConfigMutation, { data, loading, error }] = useUpdateAppConfigMutation({
 *   variables: {
 *      appConfig: // value for 'appConfig'
 *   },
 * });
 */
export function useUpdateAppConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAppConfigMutation,
    UpdateAppConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAppConfigMutation,
    UpdateAppConfigMutationVariables
  >(UpdateAppConfigDocument, options);
}
export type UpdateAppConfigMutationHookResult = ReturnType<
  typeof useUpdateAppConfigMutation
>;
export type UpdateAppConfigMutationResult =
  Apollo.MutationResult<UpdateAppConfigMutation>;
export type UpdateAppConfigMutationOptions = Apollo.BaseMutationOptions<
  UpdateAppConfigMutation,
  UpdateAppConfigMutationVariables
>;
export const CreateCurrenciesDocument = gql`
  mutation CreateCurrencies($currency: CreateCurrenciesInput!) {
    createCurrencies(currency: $currency) {
      CurrencyCode
      CurrencyName
      id
    }
  }
`;
export type CreateCurrenciesMutationFn = Apollo.MutationFunction<
  CreateCurrenciesMutation,
  CreateCurrenciesMutationVariables
>;

/**
 * __useCreateCurrenciesMutation__
 *
 * To run a mutation, you first call `useCreateCurrenciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCurrenciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCurrenciesMutation, { data, loading, error }] = useCreateCurrenciesMutation({
 *   variables: {
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useCreateCurrenciesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCurrenciesMutation,
    CreateCurrenciesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCurrenciesMutation,
    CreateCurrenciesMutationVariables
  >(CreateCurrenciesDocument, options);
}
export type CreateCurrenciesMutationHookResult = ReturnType<
  typeof useCreateCurrenciesMutation
>;
export type CreateCurrenciesMutationResult =
  Apollo.MutationResult<CreateCurrenciesMutation>;
export type CreateCurrenciesMutationOptions = Apollo.BaseMutationOptions<
  CreateCurrenciesMutation,
  CreateCurrenciesMutationVariables
>;
export const DeleteCurrenciesDocument = gql`
  mutation DeleteCurrencies($currencyId: String!) {
    deleteCurrencies(currencyId: $currencyId)
  }
`;
export type DeleteCurrenciesMutationFn = Apollo.MutationFunction<
  DeleteCurrenciesMutation,
  DeleteCurrenciesMutationVariables
>;

/**
 * __useDeleteCurrenciesMutation__
 *
 * To run a mutation, you first call `useDeleteCurrenciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCurrenciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCurrenciesMutation, { data, loading, error }] = useDeleteCurrenciesMutation({
 *   variables: {
 *      currencyId: // value for 'currencyId'
 *   },
 * });
 */
export function useDeleteCurrenciesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCurrenciesMutation,
    DeleteCurrenciesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCurrenciesMutation,
    DeleteCurrenciesMutationVariables
  >(DeleteCurrenciesDocument, options);
}
export type DeleteCurrenciesMutationHookResult = ReturnType<
  typeof useDeleteCurrenciesMutation
>;
export type DeleteCurrenciesMutationResult =
  Apollo.MutationResult<DeleteCurrenciesMutation>;
export type DeleteCurrenciesMutationOptions = Apollo.BaseMutationOptions<
  DeleteCurrenciesMutation,
  DeleteCurrenciesMutationVariables
>;
export const GetCurrenciesDocument = gql`
  query GetCurrencies {
    getCurrencies {
      CurrencyCode
      CurrencyName
      id
    }
  }
`;

/**
 * __useGetCurrenciesQuery__
 *
 * To run a query within a React component, call `useGetCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrenciesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCurrenciesQuery,
    GetCurrenciesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCurrenciesQuery, GetCurrenciesQueryVariables>(
    GetCurrenciesDocument,
    options,
  );
}
export function useGetCurrenciesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCurrenciesQuery,
    GetCurrenciesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCurrenciesQuery, GetCurrenciesQueryVariables>(
    GetCurrenciesDocument,
    options,
  );
}
export function useGetCurrenciesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCurrenciesQuery,
        GetCurrenciesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCurrenciesQuery,
    GetCurrenciesQueryVariables
  >(GetCurrenciesDocument, options);
}
export type GetCurrenciesQueryHookResult = ReturnType<
  typeof useGetCurrenciesQuery
>;
export type GetCurrenciesLazyQueryHookResult = ReturnType<
  typeof useGetCurrenciesLazyQuery
>;
export type GetCurrenciesSuspenseQueryHookResult = ReturnType<
  typeof useGetCurrenciesSuspenseQuery
>;
export type GetCurrenciesQueryResult = Apollo.QueryResult<
  GetCurrenciesQuery,
  GetCurrenciesQueryVariables
>;
export const GetCurrenciesByIdDocument = gql`
  query GetCurrenciesById($currencyId: String!) {
    getCurrenciesById(currencyId: $currencyId) {
      CurrencyCode
      CurrencyName
      id
    }
  }
`;

/**
 * __useGetCurrenciesByIdQuery__
 *
 * To run a query within a React component, call `useGetCurrenciesByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrenciesByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrenciesByIdQuery({
 *   variables: {
 *      currencyId: // value for 'currencyId'
 *   },
 * });
 */
export function useGetCurrenciesByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCurrenciesByIdQuery,
    GetCurrenciesByIdQueryVariables
  > &
    (
      | { variables: GetCurrenciesByIdQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCurrenciesByIdQuery,
    GetCurrenciesByIdQueryVariables
  >(GetCurrenciesByIdDocument, options);
}
export function useGetCurrenciesByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCurrenciesByIdQuery,
    GetCurrenciesByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCurrenciesByIdQuery,
    GetCurrenciesByIdQueryVariables
  >(GetCurrenciesByIdDocument, options);
}
export function useGetCurrenciesByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCurrenciesByIdQuery,
        GetCurrenciesByIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCurrenciesByIdQuery,
    GetCurrenciesByIdQueryVariables
  >(GetCurrenciesByIdDocument, options);
}
export type GetCurrenciesByIdQueryHookResult = ReturnType<
  typeof useGetCurrenciesByIdQuery
>;
export type GetCurrenciesByIdLazyQueryHookResult = ReturnType<
  typeof useGetCurrenciesByIdLazyQuery
>;
export type GetCurrenciesByIdSuspenseQueryHookResult = ReturnType<
  typeof useGetCurrenciesByIdSuspenseQuery
>;
export type GetCurrenciesByIdQueryResult = Apollo.QueryResult<
  GetCurrenciesByIdQuery,
  GetCurrenciesByIdQueryVariables
>;
export const UpdateCurrenciesDocument = gql`
  mutation UpdateCurrencies($currency: UpdateCurrenciesInput!) {
    updateCurrencies(currency: $currency) {
      CurrencyCode
      CurrencyName
      id
    }
  }
`;
export type UpdateCurrenciesMutationFn = Apollo.MutationFunction<
  UpdateCurrenciesMutation,
  UpdateCurrenciesMutationVariables
>;

/**
 * __useUpdateCurrenciesMutation__
 *
 * To run a mutation, you first call `useUpdateCurrenciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrenciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrenciesMutation, { data, loading, error }] = useUpdateCurrenciesMutation({
 *   variables: {
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useUpdateCurrenciesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCurrenciesMutation,
    UpdateCurrenciesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCurrenciesMutation,
    UpdateCurrenciesMutationVariables
  >(UpdateCurrenciesDocument, options);
}
export type UpdateCurrenciesMutationHookResult = ReturnType<
  typeof useUpdateCurrenciesMutation
>;
export type UpdateCurrenciesMutationResult =
  Apollo.MutationResult<UpdateCurrenciesMutation>;
export type UpdateCurrenciesMutationOptions = Apollo.BaseMutationOptions<
  UpdateCurrenciesMutation,
  UpdateCurrenciesMutationVariables
>;
export const CreateErrorMessagesDocument = gql`
  mutation CreateErrorMessages($errorMessages: CreateErrorMessagesInput!) {
    createErrorMessages(errorMessages: $errorMessages) {
      id
      ErrorKey
      ErrorNumber
      ErrorDescription
      InAppErrorMessage {
        title
        body
      }
    }
  }
`;
export type CreateErrorMessagesMutationFn = Apollo.MutationFunction<
  CreateErrorMessagesMutation,
  CreateErrorMessagesMutationVariables
>;

/**
 * __useCreateErrorMessagesMutation__
 *
 * To run a mutation, you first call `useCreateErrorMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateErrorMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createErrorMessagesMutation, { data, loading, error }] = useCreateErrorMessagesMutation({
 *   variables: {
 *      errorMessages: // value for 'errorMessages'
 *   },
 * });
 */
export function useCreateErrorMessagesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateErrorMessagesMutation,
    CreateErrorMessagesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateErrorMessagesMutation,
    CreateErrorMessagesMutationVariables
  >(CreateErrorMessagesDocument, options);
}
export type CreateErrorMessagesMutationHookResult = ReturnType<
  typeof useCreateErrorMessagesMutation
>;
export type CreateErrorMessagesMutationResult =
  Apollo.MutationResult<CreateErrorMessagesMutation>;
export type CreateErrorMessagesMutationOptions = Apollo.BaseMutationOptions<
  CreateErrorMessagesMutation,
  CreateErrorMessagesMutationVariables
>;
export const DeleteErrorMessagesDocument = gql`
  mutation DeleteErrorMessages($errorMessagesId: String!) {
    deleteErrorMessages(errorMessagesId: $errorMessagesId)
  }
`;
export type DeleteErrorMessagesMutationFn = Apollo.MutationFunction<
  DeleteErrorMessagesMutation,
  DeleteErrorMessagesMutationVariables
>;

/**
 * __useDeleteErrorMessagesMutation__
 *
 * To run a mutation, you first call `useDeleteErrorMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteErrorMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteErrorMessagesMutation, { data, loading, error }] = useDeleteErrorMessagesMutation({
 *   variables: {
 *      errorMessagesId: // value for 'errorMessagesId'
 *   },
 * });
 */
export function useDeleteErrorMessagesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteErrorMessagesMutation,
    DeleteErrorMessagesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteErrorMessagesMutation,
    DeleteErrorMessagesMutationVariables
  >(DeleteErrorMessagesDocument, options);
}
export type DeleteErrorMessagesMutationHookResult = ReturnType<
  typeof useDeleteErrorMessagesMutation
>;
export type DeleteErrorMessagesMutationResult =
  Apollo.MutationResult<DeleteErrorMessagesMutation>;
export type DeleteErrorMessagesMutationOptions = Apollo.BaseMutationOptions<
  DeleteErrorMessagesMutation,
  DeleteErrorMessagesMutationVariables
>;
export const GetErrorMessagesDocument = gql`
  query GetErrorMessages {
    getErrorMessages {
      id
      ErrorKey
      ErrorNumber
      ErrorDescription
      InAppErrorMessage {
        title
        body
      }
    }
  }
`;

/**
 * __useGetErrorMessagesQuery__
 *
 * To run a query within a React component, call `useGetErrorMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetErrorMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetErrorMessagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetErrorMessagesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetErrorMessagesQuery,
    GetErrorMessagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetErrorMessagesQuery, GetErrorMessagesQueryVariables>(
    GetErrorMessagesDocument,
    options,
  );
}
export function useGetErrorMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetErrorMessagesQuery,
    GetErrorMessagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetErrorMessagesQuery,
    GetErrorMessagesQueryVariables
  >(GetErrorMessagesDocument, options);
}
export function useGetErrorMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetErrorMessagesQuery,
        GetErrorMessagesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetErrorMessagesQuery,
    GetErrorMessagesQueryVariables
  >(GetErrorMessagesDocument, options);
}
export type GetErrorMessagesQueryHookResult = ReturnType<
  typeof useGetErrorMessagesQuery
>;
export type GetErrorMessagesLazyQueryHookResult = ReturnType<
  typeof useGetErrorMessagesLazyQuery
>;
export type GetErrorMessagesSuspenseQueryHookResult = ReturnType<
  typeof useGetErrorMessagesSuspenseQuery
>;
export type GetErrorMessagesQueryResult = Apollo.QueryResult<
  GetErrorMessagesQuery,
  GetErrorMessagesQueryVariables
>;
export const GetErrorMessagesByIdDocument = gql`
  query GetErrorMessagesById($errorMessagesId: String!) {
    getErrorMessagesById(errorMessagesId: $errorMessagesId) {
      id
      ErrorKey
      ErrorNumber
      ErrorDescription
      InAppErrorMessage {
        title
        body
      }
    }
  }
`;

/**
 * __useGetErrorMessagesByIdQuery__
 *
 * To run a query within a React component, call `useGetErrorMessagesByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetErrorMessagesByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetErrorMessagesByIdQuery({
 *   variables: {
 *      errorMessagesId: // value for 'errorMessagesId'
 *   },
 * });
 */
export function useGetErrorMessagesByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetErrorMessagesByIdQuery,
    GetErrorMessagesByIdQueryVariables
  > &
    (
      | { variables: GetErrorMessagesByIdQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetErrorMessagesByIdQuery,
    GetErrorMessagesByIdQueryVariables
  >(GetErrorMessagesByIdDocument, options);
}
export function useGetErrorMessagesByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetErrorMessagesByIdQuery,
    GetErrorMessagesByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetErrorMessagesByIdQuery,
    GetErrorMessagesByIdQueryVariables
  >(GetErrorMessagesByIdDocument, options);
}
export function useGetErrorMessagesByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetErrorMessagesByIdQuery,
        GetErrorMessagesByIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetErrorMessagesByIdQuery,
    GetErrorMessagesByIdQueryVariables
  >(GetErrorMessagesByIdDocument, options);
}
export type GetErrorMessagesByIdQueryHookResult = ReturnType<
  typeof useGetErrorMessagesByIdQuery
>;
export type GetErrorMessagesByIdLazyQueryHookResult = ReturnType<
  typeof useGetErrorMessagesByIdLazyQuery
>;
export type GetErrorMessagesByIdSuspenseQueryHookResult = ReturnType<
  typeof useGetErrorMessagesByIdSuspenseQuery
>;
export type GetErrorMessagesByIdQueryResult = Apollo.QueryResult<
  GetErrorMessagesByIdQuery,
  GetErrorMessagesByIdQueryVariables
>;
export const UpdateErrorMessagesDocument = gql`
  mutation UpdateErrorMessages($errorMessages: UpdateErrorMessagesInput!) {
    updateErrorMessages(errorMessages: $errorMessages) {
      id
      ErrorKey
      ErrorNumber
      ErrorDescription
      InAppErrorMessage {
        title
        body
      }
    }
  }
`;
export type UpdateErrorMessagesMutationFn = Apollo.MutationFunction<
  UpdateErrorMessagesMutation,
  UpdateErrorMessagesMutationVariables
>;

/**
 * __useUpdateErrorMessagesMutation__
 *
 * To run a mutation, you first call `useUpdateErrorMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateErrorMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateErrorMessagesMutation, { data, loading, error }] = useUpdateErrorMessagesMutation({
 *   variables: {
 *      errorMessages: // value for 'errorMessages'
 *   },
 * });
 */
export function useUpdateErrorMessagesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateErrorMessagesMutation,
    UpdateErrorMessagesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateErrorMessagesMutation,
    UpdateErrorMessagesMutationVariables
  >(UpdateErrorMessagesDocument, options);
}
export type UpdateErrorMessagesMutationHookResult = ReturnType<
  typeof useUpdateErrorMessagesMutation
>;
export type UpdateErrorMessagesMutationResult =
  Apollo.MutationResult<UpdateErrorMessagesMutation>;
export type UpdateErrorMessagesMutationOptions = Apollo.BaseMutationOptions<
  UpdateErrorMessagesMutation,
  UpdateErrorMessagesMutationVariables
>;
export const LogoutUserDocument = gql`
  mutation LogoutUser {
    logoutUser {
      result
    }
  }
`;
export type LogoutUserMutationFn = Apollo.MutationFunction<
  LogoutUserMutation,
  LogoutUserMutationVariables
>;

/**
 * __useLogoutUserMutation__
 *
 * To run a mutation, you first call `useLogoutUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutUserMutation, { data, loading, error }] = useLogoutUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LogoutUserMutation,
    LogoutUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LogoutUserMutation, LogoutUserMutationVariables>(
    LogoutUserDocument,
    options,
  );
}
export type LogoutUserMutationHookResult = ReturnType<
  typeof useLogoutUserMutation
>;
export type LogoutUserMutationResult =
  Apollo.MutationResult<LogoutUserMutation>;
export type LogoutUserMutationOptions = Apollo.BaseMutationOptions<
  LogoutUserMutation,
  LogoutUserMutationVariables
>;
export const CreateMessagesDocument = gql`
  mutation CreateMessages($messages: CreateMessagesInput!) {
    createMessages(messages: $messages) {
      id
      Title
      Headline
      Summary
      Description
      StartDate
      EndDate
      Active
      TMCUsers
      TIUsers
      Renewals
      GuestUsers
      LoggedInUsers
      AllUsers
      Marketing
      MatchAll
      HasCTAButton
      IsWebLink
      WebLinkURL
      ButtonLabel
      CallToActionText
      CallToActionType
      CallToActionBtnColor
    }
  }
`;
export type CreateMessagesMutationFn = Apollo.MutationFunction<
  CreateMessagesMutation,
  CreateMessagesMutationVariables
>;

/**
 * __useCreateMessagesMutation__
 *
 * To run a mutation, you first call `useCreateMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessagesMutation, { data, loading, error }] = useCreateMessagesMutation({
 *   variables: {
 *      messages: // value for 'messages'
 *   },
 * });
 */
export function useCreateMessagesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMessagesMutation,
    CreateMessagesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateMessagesMutation,
    CreateMessagesMutationVariables
  >(CreateMessagesDocument, options);
}
export type CreateMessagesMutationHookResult = ReturnType<
  typeof useCreateMessagesMutation
>;
export type CreateMessagesMutationResult =
  Apollo.MutationResult<CreateMessagesMutation>;
export type CreateMessagesMutationOptions = Apollo.BaseMutationOptions<
  CreateMessagesMutation,
  CreateMessagesMutationVariables
>;
export const DeleteMessagesDocument = gql`
  mutation DeleteMessages($messagesId: String!) {
    deleteMessages(messagesId: $messagesId)
  }
`;
export type DeleteMessagesMutationFn = Apollo.MutationFunction<
  DeleteMessagesMutation,
  DeleteMessagesMutationVariables
>;

/**
 * __useDeleteMessagesMutation__
 *
 * To run a mutation, you first call `useDeleteMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessagesMutation, { data, loading, error }] = useDeleteMessagesMutation({
 *   variables: {
 *      messagesId: // value for 'messagesId'
 *   },
 * });
 */
export function useDeleteMessagesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteMessagesMutation,
    DeleteMessagesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteMessagesMutation,
    DeleteMessagesMutationVariables
  >(DeleteMessagesDocument, options);
}
export type DeleteMessagesMutationHookResult = ReturnType<
  typeof useDeleteMessagesMutation
>;
export type DeleteMessagesMutationResult =
  Apollo.MutationResult<DeleteMessagesMutation>;
export type DeleteMessagesMutationOptions = Apollo.BaseMutationOptions<
  DeleteMessagesMutation,
  DeleteMessagesMutationVariables
>;
export const GetMessagesDocument = gql`
  query GetMessages {
    getMessages {
      id
      Title
      Headline
      Summary
      Description
      StartDate
      EndDate
      Active
      TMCUsers
      TIUsers
      Renewals
      GuestUsers
      LoggedInUsers
      AllUsers
      Marketing
      MatchAll
      HasCTAButton
      IsWebLink
      WebLinkURL
      ButtonLabel
      CallToActionText
      CallToActionType
      CallToActionBtnColor
    }
  }
`;

/**
 * __useGetMessagesQuery__
 *
 * To run a query within a React component, call `useGetMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMessagesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMessagesQuery,
    GetMessagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMessagesQuery, GetMessagesQueryVariables>(
    GetMessagesDocument,
    options,
  );
}
export function useGetMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMessagesQuery,
    GetMessagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMessagesQuery, GetMessagesQueryVariables>(
    GetMessagesDocument,
    options,
  );
}
export function useGetMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMessagesQuery,
        GetMessagesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetMessagesQuery, GetMessagesQueryVariables>(
    GetMessagesDocument,
    options,
  );
}
export type GetMessagesQueryHookResult = ReturnType<typeof useGetMessagesQuery>;
export type GetMessagesLazyQueryHookResult = ReturnType<
  typeof useGetMessagesLazyQuery
>;
export type GetMessagesSuspenseQueryHookResult = ReturnType<
  typeof useGetMessagesSuspenseQuery
>;
export type GetMessagesQueryResult = Apollo.QueryResult<
  GetMessagesQuery,
  GetMessagesQueryVariables
>;
export const GetMessagesByIdDocument = gql`
  query GetMessagesById($messagesId: String!) {
    getMessagesById(messagesId: $messagesId) {
      id
      Title
      Headline
      Summary
      Description
      StartDate
      EndDate
      Active
      TMCUsers
      TIUsers
      Renewals
      GuestUsers
      LoggedInUsers
      AllUsers
      Marketing
      MatchAll
      HasCTAButton
      IsWebLink
      WebLinkURL
      ButtonLabel
      CallToActionText
      CallToActionType
      CallToActionBtnColor
    }
  }
`;

/**
 * __useGetMessagesByIdQuery__
 *
 * To run a query within a React component, call `useGetMessagesByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagesByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagesByIdQuery({
 *   variables: {
 *      messagesId: // value for 'messagesId'
 *   },
 * });
 */
export function useGetMessagesByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMessagesByIdQuery,
    GetMessagesByIdQueryVariables
  > &
    (
      | { variables: GetMessagesByIdQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMessagesByIdQuery, GetMessagesByIdQueryVariables>(
    GetMessagesByIdDocument,
    options,
  );
}
export function useGetMessagesByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMessagesByIdQuery,
    GetMessagesByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMessagesByIdQuery,
    GetMessagesByIdQueryVariables
  >(GetMessagesByIdDocument, options);
}
export function useGetMessagesByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMessagesByIdQuery,
        GetMessagesByIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetMessagesByIdQuery,
    GetMessagesByIdQueryVariables
  >(GetMessagesByIdDocument, options);
}
export type GetMessagesByIdQueryHookResult = ReturnType<
  typeof useGetMessagesByIdQuery
>;
export type GetMessagesByIdLazyQueryHookResult = ReturnType<
  typeof useGetMessagesByIdLazyQuery
>;
export type GetMessagesByIdSuspenseQueryHookResult = ReturnType<
  typeof useGetMessagesByIdSuspenseQuery
>;
export type GetMessagesByIdQueryResult = Apollo.QueryResult<
  GetMessagesByIdQuery,
  GetMessagesByIdQueryVariables
>;
export const UpdateMessagesDocument = gql`
  mutation UpdateMessages($messages: UpdateMessagesInput!) {
    updateMessages(messages: $messages) {
      id
      Title
      Headline
      Summary
      Description
      StartDate
      EndDate
      Active
      TMCUsers
      TIUsers
      Renewals
      GuestUsers
      LoggedInUsers
      AllUsers
      Marketing
      MatchAll
      HasCTAButton
      IsWebLink
      WebLinkURL
      ButtonLabel
      CallToActionText
      CallToActionType
      CallToActionBtnColor
    }
  }
`;
export type UpdateMessagesMutationFn = Apollo.MutationFunction<
  UpdateMessagesMutation,
  UpdateMessagesMutationVariables
>;

/**
 * __useUpdateMessagesMutation__
 *
 * To run a mutation, you first call `useUpdateMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessagesMutation, { data, loading, error }] = useUpdateMessagesMutation({
 *   variables: {
 *      messages: // value for 'messages'
 *   },
 * });
 */
export function useUpdateMessagesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMessagesMutation,
    UpdateMessagesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateMessagesMutation,
    UpdateMessagesMutationVariables
  >(UpdateMessagesDocument, options);
}
export type UpdateMessagesMutationHookResult = ReturnType<
  typeof useUpdateMessagesMutation
>;
export type UpdateMessagesMutationResult =
  Apollo.MutationResult<UpdateMessagesMutation>;
export type UpdateMessagesMutationOptions = Apollo.BaseMutationOptions<
  UpdateMessagesMutation,
  UpdateMessagesMutationVariables
>;
export const CreatePolicyDocument = gql`
  mutation CreatePolicy($policy: CreatePolicyInput!) {
    createPolicy(policy: $policy) {
      id
      policyType
      header
      body
      isActive
    }
  }
`;
export type CreatePolicyMutationFn = Apollo.MutationFunction<
  CreatePolicyMutation,
  CreatePolicyMutationVariables
>;

/**
 * __useCreatePolicyMutation__
 *
 * To run a mutation, you first call `useCreatePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPolicyMutation, { data, loading, error }] = useCreatePolicyMutation({
 *   variables: {
 *      policy: // value for 'policy'
 *   },
 * });
 */
export function useCreatePolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePolicyMutation,
    CreatePolicyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePolicyMutation,
    CreatePolicyMutationVariables
  >(CreatePolicyDocument, options);
}
export type CreatePolicyMutationHookResult = ReturnType<
  typeof useCreatePolicyMutation
>;
export type CreatePolicyMutationResult =
  Apollo.MutationResult<CreatePolicyMutation>;
export type CreatePolicyMutationOptions = Apollo.BaseMutationOptions<
  CreatePolicyMutation,
  CreatePolicyMutationVariables
>;
export const DeletePolicyDocument = gql`
  mutation DeletePolicy($policyId: String!) {
    deletePolicy(policyId: $policyId)
  }
`;
export type DeletePolicyMutationFn = Apollo.MutationFunction<
  DeletePolicyMutation,
  DeletePolicyMutationVariables
>;

/**
 * __useDeletePolicyMutation__
 *
 * To run a mutation, you first call `useDeletePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePolicyMutation, { data, loading, error }] = useDeletePolicyMutation({
 *   variables: {
 *      policyId: // value for 'policyId'
 *   },
 * });
 */
export function useDeletePolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeletePolicyMutation,
    DeletePolicyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeletePolicyMutation,
    DeletePolicyMutationVariables
  >(DeletePolicyDocument, options);
}
export type DeletePolicyMutationHookResult = ReturnType<
  typeof useDeletePolicyMutation
>;
export type DeletePolicyMutationResult =
  Apollo.MutationResult<DeletePolicyMutation>;
export type DeletePolicyMutationOptions = Apollo.BaseMutationOptions<
  DeletePolicyMutation,
  DeletePolicyMutationVariables
>;
export const GetPolicyDocument = gql`
  query GetPolicy {
    getPolicy {
      id
      policyType
      header
      body
      isActive
    }
  }
`;

/**
 * __useGetPolicyQuery__
 *
 * To run a query within a React component, call `useGetPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPolicyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPolicyQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPolicyQuery,
    GetPolicyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPolicyQuery, GetPolicyQueryVariables>(
    GetPolicyDocument,
    options,
  );
}
export function useGetPolicyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPolicyQuery,
    GetPolicyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPolicyQuery, GetPolicyQueryVariables>(
    GetPolicyDocument,
    options,
  );
}
export function useGetPolicySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPolicyQuery, GetPolicyQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPolicyQuery, GetPolicyQueryVariables>(
    GetPolicyDocument,
    options,
  );
}
export type GetPolicyQueryHookResult = ReturnType<typeof useGetPolicyQuery>;
export type GetPolicyLazyQueryHookResult = ReturnType<
  typeof useGetPolicyLazyQuery
>;
export type GetPolicySuspenseQueryHookResult = ReturnType<
  typeof useGetPolicySuspenseQuery
>;
export type GetPolicyQueryResult = Apollo.QueryResult<
  GetPolicyQuery,
  GetPolicyQueryVariables
>;
export const GetPolicyByIdDocument = gql`
  query GetPolicyById($policyId: String!) {
    getPolicyById(policyId: $policyId) {
      id
      policyType
      header
      body
      isActive
    }
  }
`;

/**
 * __useGetPolicyByIdQuery__
 *
 * To run a query within a React component, call `useGetPolicyByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPolicyByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPolicyByIdQuery({
 *   variables: {
 *      policyId: // value for 'policyId'
 *   },
 * });
 */
export function useGetPolicyByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPolicyByIdQuery,
    GetPolicyByIdQueryVariables
  > &
    (
      | { variables: GetPolicyByIdQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPolicyByIdQuery, GetPolicyByIdQueryVariables>(
    GetPolicyByIdDocument,
    options,
  );
}
export function useGetPolicyByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPolicyByIdQuery,
    GetPolicyByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPolicyByIdQuery, GetPolicyByIdQueryVariables>(
    GetPolicyByIdDocument,
    options,
  );
}
export function useGetPolicyByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPolicyByIdQuery,
        GetPolicyByIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPolicyByIdQuery,
    GetPolicyByIdQueryVariables
  >(GetPolicyByIdDocument, options);
}
export type GetPolicyByIdQueryHookResult = ReturnType<
  typeof useGetPolicyByIdQuery
>;
export type GetPolicyByIdLazyQueryHookResult = ReturnType<
  typeof useGetPolicyByIdLazyQuery
>;
export type GetPolicyByIdSuspenseQueryHookResult = ReturnType<
  typeof useGetPolicyByIdSuspenseQuery
>;
export type GetPolicyByIdQueryResult = Apollo.QueryResult<
  GetPolicyByIdQuery,
  GetPolicyByIdQueryVariables
>;
export const UpdatePolicyDocument = gql`
  mutation UpdatePolicy($policy: UpdatePolicyInput!) {
    updatePolicy(policy: $policy) {
      id
      policyType
      header
      body
      isActive
    }
  }
`;
export type UpdatePolicyMutationFn = Apollo.MutationFunction<
  UpdatePolicyMutation,
  UpdatePolicyMutationVariables
>;

/**
 * __useUpdatePolicyMutation__
 *
 * To run a mutation, you first call `useUpdatePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePolicyMutation, { data, loading, error }] = useUpdatePolicyMutation({
 *   variables: {
 *      policy: // value for 'policy'
 *   },
 * });
 */
export function useUpdatePolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePolicyMutation,
    UpdatePolicyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePolicyMutation,
    UpdatePolicyMutationVariables
  >(UpdatePolicyDocument, options);
}
export type UpdatePolicyMutationHookResult = ReturnType<
  typeof useUpdatePolicyMutation
>;
export type UpdatePolicyMutationResult =
  Apollo.MutationResult<UpdatePolicyMutation>;
export type UpdatePolicyMutationOptions = Apollo.BaseMutationOptions<
  UpdatePolicyMutation,
  UpdatePolicyMutationVariables
>;
export const CreatePushNotificationDocument = gql`
  mutation CreatePushNotification(
    $pushNotification: CreatePushNotificationInput!
  ) {
    createPushNotification(pushNotification: $pushNotification) {
      pushNotification {
        id
        name
        title
        scheduleId
        body
        deeplink
        dueOn
        throttleRate
        autoPauseSchedule
        pauseSendingTime
        resumeSendingTime
        application
        tmcUsers
        tiUsers
        deviceOS
        status
      }
      scheduleResponse {
        scheduleId
        message
      }
    }
  }
`;
export type CreatePushNotificationMutationFn = Apollo.MutationFunction<
  CreatePushNotificationMutation,
  CreatePushNotificationMutationVariables
>;

/**
 * __useCreatePushNotificationMutation__
 *
 * To run a mutation, you first call `useCreatePushNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePushNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPushNotificationMutation, { data, loading, error }] = useCreatePushNotificationMutation({
 *   variables: {
 *      pushNotification: // value for 'pushNotification'
 *   },
 * });
 */
export function useCreatePushNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePushNotificationMutation,
    CreatePushNotificationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePushNotificationMutation,
    CreatePushNotificationMutationVariables
  >(CreatePushNotificationDocument, options);
}
export type CreatePushNotificationMutationHookResult = ReturnType<
  typeof useCreatePushNotificationMutation
>;
export type CreatePushNotificationMutationResult =
  Apollo.MutationResult<CreatePushNotificationMutation>;
export type CreatePushNotificationMutationOptions = Apollo.BaseMutationOptions<
  CreatePushNotificationMutation,
  CreatePushNotificationMutationVariables
>;
export const DeletePushNotificationDocument = gql`
  mutation DeletePushNotification($deleteID: DeletePushNotificationInput!) {
    deletePushNotification(deleteID: $deleteID)
  }
`;
export type DeletePushNotificationMutationFn = Apollo.MutationFunction<
  DeletePushNotificationMutation,
  DeletePushNotificationMutationVariables
>;

/**
 * __useDeletePushNotificationMutation__
 *
 * To run a mutation, you first call `useDeletePushNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePushNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePushNotificationMutation, { data, loading, error }] = useDeletePushNotificationMutation({
 *   variables: {
 *      deleteID: // value for 'deleteID'
 *   },
 * });
 */
export function useDeletePushNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeletePushNotificationMutation,
    DeletePushNotificationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeletePushNotificationMutation,
    DeletePushNotificationMutationVariables
  >(DeletePushNotificationDocument, options);
}
export type DeletePushNotificationMutationHookResult = ReturnType<
  typeof useDeletePushNotificationMutation
>;
export type DeletePushNotificationMutationResult =
  Apollo.MutationResult<DeletePushNotificationMutation>;
export type DeletePushNotificationMutationOptions = Apollo.BaseMutationOptions<
  DeletePushNotificationMutation,
  DeletePushNotificationMutationVariables
>;
export const GetPushNotificationDocument = gql`
  query GetPushNotification {
    getPushNotification {
      pushNotification {
        id
        name
        title
        scheduleId
        body
        deeplink
        dueOn
        throttleRate
        autoPauseSchedule
        pauseSendingTime
        resumeSendingTime
        application
        tmcUsers
        tiUsers
        deviceOS
        status
      }
      allSchedules {
        schedules {
          scheduleId
          appName
          notificationName
          deviceAttr
          notificationMsg {
            notification {
              title
              body
            }
          }
          subscriptions {
            tmcUsers
            tiUsers
          }
          createdOn
          updatedOn
          dueOn
          completedOn
          status
          numOptedOut
          numSuccess
          numFailure
          throttleRate
          pauseSendingTime
          resumeSendingTime
        }
      }
    }
  }
`;

/**
 * __useGetPushNotificationQuery__
 *
 * To run a query within a React component, call `useGetPushNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPushNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPushNotificationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPushNotificationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPushNotificationQuery,
    GetPushNotificationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPushNotificationQuery,
    GetPushNotificationQueryVariables
  >(GetPushNotificationDocument, options);
}
export function useGetPushNotificationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPushNotificationQuery,
    GetPushNotificationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPushNotificationQuery,
    GetPushNotificationQueryVariables
  >(GetPushNotificationDocument, options);
}
export function useGetPushNotificationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPushNotificationQuery,
        GetPushNotificationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPushNotificationQuery,
    GetPushNotificationQueryVariables
  >(GetPushNotificationDocument, options);
}
export type GetPushNotificationQueryHookResult = ReturnType<
  typeof useGetPushNotificationQuery
>;
export type GetPushNotificationLazyQueryHookResult = ReturnType<
  typeof useGetPushNotificationLazyQuery
>;
export type GetPushNotificationSuspenseQueryHookResult = ReturnType<
  typeof useGetPushNotificationSuspenseQuery
>;
export type GetPushNotificationQueryResult = Apollo.QueryResult<
  GetPushNotificationQuery,
  GetPushNotificationQueryVariables
>;
export const GetPushNotificationByIdDocument = gql`
  query GetPushNotificationById($pushNotificationId: String!) {
    getPushNotificationById(pushNotificationId: $pushNotificationId) {
      id
      name
      title
      scheduleId
      body
      deeplink
      dueOn
      throttleRate
      autoPauseSchedule
      pauseSendingTime
      resumeSendingTime
      application
      tmcUsers
      tiUsers
      deviceOS
      status
    }
  }
`;

/**
 * __useGetPushNotificationByIdQuery__
 *
 * To run a query within a React component, call `useGetPushNotificationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPushNotificationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPushNotificationByIdQuery({
 *   variables: {
 *      pushNotificationId: // value for 'pushNotificationId'
 *   },
 * });
 */
export function useGetPushNotificationByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPushNotificationByIdQuery,
    GetPushNotificationByIdQueryVariables
  > &
    (
      | { variables: GetPushNotificationByIdQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPushNotificationByIdQuery,
    GetPushNotificationByIdQueryVariables
  >(GetPushNotificationByIdDocument, options);
}
export function useGetPushNotificationByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPushNotificationByIdQuery,
    GetPushNotificationByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPushNotificationByIdQuery,
    GetPushNotificationByIdQueryVariables
  >(GetPushNotificationByIdDocument, options);
}
export function useGetPushNotificationByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPushNotificationByIdQuery,
        GetPushNotificationByIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPushNotificationByIdQuery,
    GetPushNotificationByIdQueryVariables
  >(GetPushNotificationByIdDocument, options);
}
export type GetPushNotificationByIdQueryHookResult = ReturnType<
  typeof useGetPushNotificationByIdQuery
>;
export type GetPushNotificationByIdLazyQueryHookResult = ReturnType<
  typeof useGetPushNotificationByIdLazyQuery
>;
export type GetPushNotificationByIdSuspenseQueryHookResult = ReturnType<
  typeof useGetPushNotificationByIdSuspenseQuery
>;
export type GetPushNotificationByIdQueryResult = Apollo.QueryResult<
  GetPushNotificationByIdQuery,
  GetPushNotificationByIdQueryVariables
>;
export const UpdatePushNotificationDocument = gql`
  mutation UpdatePushNotification(
    $pushNotification: UpdatePushNotificationInput!
  ) {
    updatePushNotification(pushNotification: $pushNotification) {
      id
      name
      title
      scheduleId
      body
      deeplink
      dueOn
      throttleRate
      autoPauseSchedule
      pauseSendingTime
      resumeSendingTime
      application
      tmcUsers
      tiUsers
      deviceOS
      status
    }
  }
`;
export type UpdatePushNotificationMutationFn = Apollo.MutationFunction<
  UpdatePushNotificationMutation,
  UpdatePushNotificationMutationVariables
>;

/**
 * __useUpdatePushNotificationMutation__
 *
 * To run a mutation, you first call `useUpdatePushNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePushNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePushNotificationMutation, { data, loading, error }] = useUpdatePushNotificationMutation({
 *   variables: {
 *      pushNotification: // value for 'pushNotification'
 *   },
 * });
 */
export function useUpdatePushNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePushNotificationMutation,
    UpdatePushNotificationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePushNotificationMutation,
    UpdatePushNotificationMutationVariables
  >(UpdatePushNotificationDocument, options);
}
export type UpdatePushNotificationMutationHookResult = ReturnType<
  typeof useUpdatePushNotificationMutation
>;
export type UpdatePushNotificationMutationResult =
  Apollo.MutationResult<UpdatePushNotificationMutation>;
export type UpdatePushNotificationMutationOptions = Apollo.BaseMutationOptions<
  UpdatePushNotificationMutation,
  UpdatePushNotificationMutationVariables
>;
export const CreateSessionDocument = gql`
  mutation CreateSession($UserName: String!, $Token: String!) {
    createSession(UserName: $UserName, Token: $Token) {
      uuid
      hashedEmail
    }
  }
`;
export type CreateSessionMutationFn = Apollo.MutationFunction<
  CreateSessionMutation,
  CreateSessionMutationVariables
>;

/**
 * __useCreateSessionMutation__
 *
 * To run a mutation, you first call `useCreateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSessionMutation, { data, loading, error }] = useCreateSessionMutation({
 *   variables: {
 *      UserName: // value for 'UserName'
 *      Token: // value for 'Token'
 *   },
 * });
 */
export function useCreateSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSessionMutation,
    CreateSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateSessionMutation,
    CreateSessionMutationVariables
  >(CreateSessionDocument, options);
}
export type CreateSessionMutationHookResult = ReturnType<
  typeof useCreateSessionMutation
>;
export type CreateSessionMutationResult =
  Apollo.MutationResult<CreateSessionMutation>;
export type CreateSessionMutationOptions = Apollo.BaseMutationOptions<
  CreateSessionMutation,
  CreateSessionMutationVariables
>;
export const DeleteSessionDocument = gql`
  mutation DeleteSession($id: ID!) {
    deleteSession(id: $id)
  }
`;
export type DeleteSessionMutationFn = Apollo.MutationFunction<
  DeleteSessionMutation,
  DeleteSessionMutationVariables
>;

/**
 * __useDeleteSessionMutation__
 *
 * To run a mutation, you first call `useDeleteSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSessionMutation, { data, loading, error }] = useDeleteSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteSessionMutation,
    DeleteSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteSessionMutation,
    DeleteSessionMutationVariables
  >(DeleteSessionDocument, options);
}
export type DeleteSessionMutationHookResult = ReturnType<
  typeof useDeleteSessionMutation
>;
export type DeleteSessionMutationResult =
  Apollo.MutationResult<DeleteSessionMutation>;
export type DeleteSessionMutationOptions = Apollo.BaseMutationOptions<
  DeleteSessionMutation,
  DeleteSessionMutationVariables
>;
export const GetSessionDocument = gql`
  query GetSession($id: ID!) {
    getSession(id: $id) {
      uuid
      hashedEmail
    }
  }
`;

/**
 * __useGetSessionQuery__
 *
 * To run a query within a React component, call `useGetSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSessionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSessionQuery,
    GetSessionQueryVariables
  > &
    (
      | { variables: GetSessionQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSessionQuery, GetSessionQueryVariables>(
    GetSessionDocument,
    options,
  );
}
export function useGetSessionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSessionQuery,
    GetSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSessionQuery, GetSessionQueryVariables>(
    GetSessionDocument,
    options,
  );
}
export function useGetSessionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSessionQuery,
        GetSessionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSessionQuery, GetSessionQueryVariables>(
    GetSessionDocument,
    options,
  );
}
export type GetSessionQueryHookResult = ReturnType<typeof useGetSessionQuery>;
export type GetSessionLazyQueryHookResult = ReturnType<
  typeof useGetSessionLazyQuery
>;
export type GetSessionSuspenseQueryHookResult = ReturnType<
  typeof useGetSessionSuspenseQuery
>;
export type GetSessionQueryResult = Apollo.QueryResult<
  GetSessionQuery,
  GetSessionQueryVariables
>;
export const SessionsDocument = gql`
  query Sessions {
    sessions {
      uuid
      hashedEmail
    }
  }
`;

/**
 * __useSessionsQuery__
 *
 * To run a query within a React component, call `useSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSessionsQuery(
  baseOptions?: Apollo.QueryHookOptions<SessionsQuery, SessionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SessionsQuery, SessionsQueryVariables>(
    SessionsDocument,
    options,
  );
}
export function useSessionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SessionsQuery,
    SessionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SessionsQuery, SessionsQueryVariables>(
    SessionsDocument,
    options,
  );
}
export function useSessionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SessionsQuery, SessionsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SessionsQuery, SessionsQueryVariables>(
    SessionsDocument,
    options,
  );
}
export type SessionsQueryHookResult = ReturnType<typeof useSessionsQuery>;
export type SessionsLazyQueryHookResult = ReturnType<
  typeof useSessionsLazyQuery
>;
export type SessionsSuspenseQueryHookResult = ReturnType<
  typeof useSessionsSuspenseQuery
>;
export type SessionsQueryResult = Apollo.QueryResult<
  SessionsQuery,
  SessionsQueryVariables
>;
export const UpdateSessionDocument = gql`
  mutation UpdateSession($id: ID!, $UserName: String!, $Token: String!) {
    updateSession(id: $id, UserName: $UserName, Token: $Token) {
      uuid
      hashedEmail
    }
  }
`;
export type UpdateSessionMutationFn = Apollo.MutationFunction<
  UpdateSessionMutation,
  UpdateSessionMutationVariables
>;

/**
 * __useUpdateSessionMutation__
 *
 * To run a mutation, you first call `useUpdateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSessionMutation, { data, loading, error }] = useUpdateSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      UserName: // value for 'UserName'
 *      Token: // value for 'Token'
 *   },
 * });
 */
export function useUpdateSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSessionMutation,
    UpdateSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSessionMutation,
    UpdateSessionMutationVariables
  >(UpdateSessionDocument, options);
}
export type UpdateSessionMutationHookResult = ReturnType<
  typeof useUpdateSessionMutation
>;
export type UpdateSessionMutationResult =
  Apollo.MutationResult<UpdateSessionMutation>;
export type UpdateSessionMutationOptions = Apollo.BaseMutationOptions<
  UpdateSessionMutation,
  UpdateSessionMutationVariables
>;
